var React = require('react');

function Up (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icons / chevron / up"),React.createElement("g",{"id":"icons-/-chevron-/-up","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("polygon",{"id":"chevron-up","fill":"currentColor","transform":"translate(11.997000, 12.000500) scale(1, -1) translate(-11.997000, -12.000500) ","points":"19.29 6.94 11.996 14.234 4.704 6.94 3.29 8.355 11.996 17.061 20.704 8.355"}))]);
}

Up.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = Up;

Up.default = Up;
